export default (count, singular, plural) => {
  return count === 1 ? `${count} ${singular}` : `${count} ${plural}`
}



// WEBPACK FOOTER //
// ./src/filters/pluralize.js